import React from 'react';
import './UnitCard.css';
import DefaultUnitIcon from '../DefaultUnitIcon/DefaultUnitIcon';
import logComponent from '../../common/logComponent';

export default function UnitCard({ unit, border }) {
  if (logComponent('UnitCard')) { console.debug('UnitCard rendered'); }

  return (
    <div className={'Unit-Card' + (border ? ' Unit-Card--border' : '')}>
      <div className="Unit-Card__image">
        <DefaultUnitIcon />
      </div>
      <p className="Unit-Card__name">{unit.name}</p>
    </div>
  );
}